module.exports = __webpack_public_path__ + "img/logo-pab.1f46462e.png";